// extracted by mini-css-extract-plugin
module.exports = {"spinner__container":"Loader_spinner__container__22gG9","spinner":"Loader_spinner__QrcIT"};